import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

export type ExclusionEntityType = "PAYMENT" | "SUBSCRIPTION";

export type FinanceExclusionHistory = {
  id: string;
  entityType: ExclusionEntityType;

  renterId?: string;
  paymentId?: string;
  authorName?: string;

  renterName?: string;
  description?: string | null;
  value?: number | null;

  reason?: string | null;

  invoiceUrl?: string | null;
  snapshot?: unknown;
};

const API_URL = `${import.meta.env.VITE_API_URL}/history-exclusion`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getFinanceExclusionHistory(params: {
  entityType: ExclusionEntityType;
  search?: string;
  limit?: number;
  page?: number;
}) {
  const query = new URLSearchParams();
  query.append("entityType", params.entityType);

  if (params.search) query.append("q", params.search);
  if (params.limit) query.append("limit", String(params.limit));
  if (params.page) query.append("page", String(params.page));

  const url = `${API_URL}/?${query.toString()}`;

  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  const result = (await makeRequestDebounced(url, options) as ApiResponseType<FinanceExclusionHistory[]> & { totalItems: number });

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export function getFinanceExclusionHistoryDetails(params: {
  entityType: ExclusionEntityType;
  id: string;
}) {
  const url = `${API_URL}/${params.entityType}/${params.id}`;

  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequest(url, options) as Promise<ApiResponseType<FinanceExclusionHistory>>;
}
